/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import ErrorLabel from '../ErrorLabel';
import styled from 'styled-components';

import { transformLabels } from '../../../../utils/misc';
import { Colors } from '../../../../scss/common/style';

interface Props {
  name: string;
  initialValue?: string | string[];
  onChange: (value: string | string[]) => void;
  getOptionLabel: (option: any) => string;
  queryFields?: string[];
  isMulti?: boolean;
  cols?: number;
  options: any[];
  defaultInputValue?: string;
  selectedValue?: string;
  currentValue?: string;
  height?: string;
}

export default function AutocompleteStaticComponent({
  name,
  initialValue = '',
  onChange,
  getOptionLabel,
  queryFields = ['name'],
  isMulti = false,
  cols = 6,
  options,
  defaultInputValue = '',
  selectedValue = '',
  currentValue = '',
  height = '33px',
}: Props): JSX.Element {
  const [initialObject, setInitialObject] = useState(null);

  const findByValue = (fullData, specificValue) => {
    return fullData.find((e) => e.value === specificValue);
  };

  useEffect(() => {
    let ini = null;
    if (isMulti) {
      ini = initialValue;
    } else {
      ini = findByValue(options, initialValue);
    }
    setInitialObject(ini);
  }, []);

  const onChangeLocal = (selectedItems) => {
    if (Array.isArray(selectedItems)) {
      const vals = [];
      selectedItems.forEach((selectedItem) => {
        vals.push(selectedItem);
      });
      onChange(name, vals);
    } else if (selectedItems === null) {
      onChange(name, '');
    } else {
      onChange(name, selectedItems?.value);
    }
  };

  return (
    <WrapperInput className={`col-sm-${cols}`}>
      <StyledLabel className="ak-form-labels" htmlFor={name}>
        {transformLabels(name)}
      </StyledLabel>
      {initialObject !== null && (
        <>
          <StyledSelect
            isMulti={isMulti}
            getOptionLabel={getOptionLabel}
            getOptionValue={(option) => option.value}
            options={options}
            onChange={(defaultValue) => onChangeLocal(defaultValue)}
            defaultValue={initialObject}
            selectedItems={initialObject}
            height={height}
            styles={{
              menu: (provided, state) => ({
                ...provided,
                zIndex: 9999,
                backgroundColor: state.isSelected ? Colors.darkBrown : '#FBFBFB!important',
                color: state.isSelected ? '#fff!important' : 'black!important',
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? Colors.darkBrown : '#FBFBFB!important',
                color: state.isSelected ? '#fff!important' : 'black!important',
                '&:hover': {
                  backgroundColor: '#eeee !important',
                  color: Colors.darkBrown,
                },
                padding: 10,
                margin: 0,
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderRadius: 200,
                zIndex: 10,
                minHeight: height,
                height: height,

                border: '1px solid #EEEEEE !important',
                '&:hover': {
                  border: '1px solid #EEEEEE !important',
                },
                '&:focus': {
                  border: '1px solid #EEEEEE !important',
                },
                '&:active': {
                  border: '1px solid #EEEEEE !important',
                },
              }),
              indicatorsContainer: (provided, state) => ({
                ...provided,
                color: Colors.newOrage,
                height: 31,
                alignItems: 'center',
              }),

              dropdownIndicator: (provided, state) => ({
                ...provided,
                color: Colors.newOrage,
                '&:hover': {
                  color: Colors.newOrage,
                },
                '&:active': {
                  color: Colors.newOrage,
                },
                '&:focus': {
                  color: Colors.newOrage,
                },
              }),
            }}
          />
          {/* {touched && touched[name] && errors[name] && <ErrorLabel error={errors[name]} />} */}
        </>
      )}
    </WrapperInput>
  );
}

const StyledSelect = styled(Select)`
  font-size: 14px;
  font-weight: 400;

  &:active {
    box-shadow: none !important;
    border-color: #eeeeee !important;
  }
  &:hover {
    box-shadow: none !important;
    border-color: #eeeeee !important;
  }
  &:focus {
    box-shadow: none !important;
    border-color: #eeeeee !important;
  }
  &:target {
    box-shadow: none !important;
    border-color: #eeeeee !important;
  }
  &:visited {
    box-shadow: none !important;
    border-color: #eeeeee !important;
  }
`;

const WrapperInput = styled.div`
  padding: 0;
`;

const StyledLabel = styled.label`
  font-size: 15px;
  color: ${Colors.darkBrown};
  font-weight: 700;
  line-height: 17px;
  margin-left: 8px;
  margin-bottom: 11px;
`;
